<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}" 
      class="rew19_popContainer big" id="pop_changeSkincare" style="display: block">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">스킨케어코드 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <ul class="rew19_transition_table in_popSearch">
          <li>
            <em class="with_type1">스킨케어코드</em>
            <div class="right_btn">
              <div class="rew19_form_full">
                <input 
                  v-model.trim="viewData.agm_code"
                  @input="toUpper()"
                  ref="agm_code"
                  title="변경할 스킨케어코드 입력" 
                  type="text" 
                  class="autoFocus rew19_inputTxt_t1" 
                  placeholder="스킨케어코드를 입력하세요"
                  >
              </div>
              <span class="type1">
                <a @click="openSkinCareCodeListDialog" class="rew19_btn_T1">코드조회</a>
              </span>
            </div>
          </li>
          <li>
            <em class="with_type1">이름</em>
            <div class="rew19_form_full">
              <input 
                v-model.trim="viewData.agm_name"
                ref="agm_name"
                title="변경할 스킨케어코드 이름 입력" 
                type="text" 
                class="autoFocus rew19_inputTxt_t1" placeholder="스킨케어코드 이름을 입력하세요.">
            </div>
          </li>
          <li>
            <em class="with_type1">코드별명</em>
            <div class="rew19_form_full">
              <input v-model.trim="viewData.agm_detail" 
                ref="agm_detail"
                title="변경할 스킨케어코드 별명 입력" 
                type="text" 
                class="autoFocus rew19_inputTxt_t1" placeholder="스킨케어코드 별명을 입력하세요.">
            </div>
          </li>
        </ul>
        
        <ul class="rew19_small_dotList addMg">
          <li>이번달 결제가 이미 완료된 경우, 스킨 케어 코드 변경 사항은 익월부터 적용됩니다.</li>
        </ul>
            
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>        
    </div>  
    <!--//popup 끝-->

    <skin-care-code-list-dialog
      :show="skinCareCodeListDialogShow"      
      @close="setSkinCareCodeFromList"
      ref="skinCareCodeListDialog"
    ></skin-care-code-list-dialog>
  </div>
</template>

<script>
import * as ErrMsg from "@/utils/error_msg";
import SkinCareCodeListDialog from '@/components/popup/SkinCareCodeListDialog';

export default {
  name: 'SkinCareCodeDialog',  
  components: { SkinCareCodeListDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    }    
  },
  data() {
    return {      
      currentZIndex : 2000,

      paramData :{
        memberId : null,
      },

      skinCareCodeListDialogShow : false,
      skinCareCodeListDialog : {},

      viewData : {
        agm_code: "M6FG8P",
        agm_detail: "베이직 스킨케어 세트",        
        agm_name: "관리자",       
      },

      retSkinCode : null,
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.retSkinCode : null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(!_this.validation()){
        return;
      }

      _this.retSkinCode = {
        ..._this.viewData
      };
      
      _this.onClose(true);
    },

    /**
     * API Request
     */    
    

    /**
     * Local 
     */
    initData(paramData){
      let _this = this;

      _this.paramData = paramData;
      
      _this.viewData = {
        ..._this.viewData,
        agm_code : paramData.agm_code,
        agm_name : paramData.agm_name,
        agm_detail : paramData.agm_detail        
      };
    },

    loadData(){
      let _this = this;
      
    },

    //Open dialog 스킨 케어 코드 List
    openSkinCareCodeListDialog(){
      let _this = this;

      //pass data to dialog      
      _this.skinCareCodeListDialog = {
        ..._this.skinCareCodeListDialog,
        memberId : _this.paramData.memberId
      };
      
      _this.$refs.skinCareCodeListDialog.initData(_this.skinCareCodeListDialog);

      _this.skinCareCodeListDialogShow = true;
    },

    //스킨 케어 코드 변경
    setSkinCareCodeFromList(isOk, data){
      let _this = this;

      _this.skinCareCodeListDialogShow = false;      

      if(!isOk){
        //Do nothing
        return;
      }

      _this.viewData.agm_code = data.assessmentCode;
      _this.viewData.agm_name = data.personName;
      _this.viewData.agm_detail = data.assessmentLabel;
    },


    validation(){
      //스킨 케어 코드 확인
      let _this = this;
      let agm_info = _this.viewData;
      let chVal = "";

      //스킨케어코드
      chVal = agm_info.agm_code;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 정보 입력이 반드시 필요합니다. 코드를 입력해주세요.")
        .then(res => {
          _this.$refs.agm_code.focus();
        });   
        return false;
      }

      let regExSkinCareCode = /^[A-Z0-9+]*$/;
      if(!regExSkinCareCode.test(chVal)){
        _this.$dialogs.alert("에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 코드는 영어 및 숫자만 가능합니다.")
        .then(res => {
          _this.$refs.agm_code.focus();
        });   
        return false;
      }

      //이름
      chVal = agm_info.agm_name;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("스킨케어 코드 이름을 입력해 주세요.")
        .then(res => {
          _this.$refs.agm_name.focus();
        });   
        return false;
      }

      // //코드 별병
      // chVal = agm_info.agm_detail;
      // if(!chVal || chVal.trim() == ""){
      //   _this.$dialogs.alert("스킨케어 코드별명을 입력해 주세요.")
      //   .then(res => {
      //     _this.$refs.agm_detail.focus();
      //   });   
      //   return false;
      // }
    
      return true;
    },
    toUpper(){
      let _this = this;

      _this.viewData.agm_code = _this.viewData.agm_code.toUpperCase();
     
    }
  }
}
</script>
<style>
a.rew19_btn_T1{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/SkinCareCodeDialog.vue